/** Must match backend `COUPON_NOTIFICATION_QUE_CHUNK_SIZE` in ableMart_backend. */
export const NOTIFICATION_QUE_CHUNK_SIZE = 3000;

export const notificationQueueChunkHint = (userCount) => {
  if (!userCount || userCount <= NOTIFICATION_QUE_CHUNK_SIZE) return null;
  const queueCount = Math.ceil(userCount / NOTIFICATION_QUE_CHUNK_SIZE);
  return `This upload will create ${queueCount} queues (up to ${NOTIFICATION_QUE_CHUNK_SIZE.toLocaleString()} users each).`;
};
